import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AlertCircle, Home } from 'lucide-react';

const NotFound: React.FC = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <Row className="w-100">
        <Col lg={6} className="mx-auto text-center">
          <AlertCircle size={80} className="text-danger mb-4" />
          <h1 className="display-1 fw-bold text-dark mb-3">404</h1>
          <h2 className="h3 mb-3">Page Not Found</h2>
          <p className="lead text-muted mb-4">
            Sorry! The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/" className="btn btn-success btn-lg me-3">
            <Home size={20} className="me-2" />
            Go Home
          </Link>
          <Link to="/cart" className="btn btn-outline-success btn-lg">
            Continue Shopping
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
